<div class="container">
  <mat-card class="militar-info">
    <h2>Dados do Militar</h2>
    <div class="info-column">
      <span><strong>Matricula:</strong> {{ beneficiario.matricula }}</span>
      <span><strong>Nome:</strong> {{ beneficiario.nome }}</span>
      <span><strong>ID Funcional:</strong> {{ beneficiario.idFuncional }}</span>
      <span><strong>CPF:</strong> {{ beneficiario.cpf }}</span>
      <span><strong>Orgao:</strong> {{ beneficiario.orgao?.sigla }}</span>
    </div>
  </mat-card>

  <app-etapas-beneficio [etapaSelecionada]="8"></app-etapas-beneficio>

  <h1 class="page-title">Composicao do Ato</h1>

  <mat-card class="tabela-card">
    <h3 class="section-title">Valores do Ato</h3>
    <p>Informe os valores e a fonte conferida. A importação automática da folha ainda não está disponível. O documento utiliza a última composição salva.</p>
    <mat-form-field appearance="outline" class="full-width"><mat-label>Fonte dos valores (folha/competência/documento)</mat-label><input matInput [(ngModel)]="fonteValores" (ngModelChange)="marcarAlteracao()" required /></mat-form-field>

    <div *ngIf="loading" class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <table
      mat-table
      [dataSource]="rubricas"
      class="mat-elevation-z2"
      *ngIf="!loading"
    >
      <!-- Checkbox Selecionar -->
      <ng-container matColumnDef="selecionar">
        <th mat-header-cell *matHeaderCellDef>Beneficio</th>
        <td mat-cell *matCellDef="let r">
          <mat-checkbox
            [checked]="r.selecionada"
            (change)="toggleSelecao(r)"
          ></mat-checkbox>
        </td>
      </ng-container>

      <!-- Codigo -->
      <ng-container matColumnDef="codigo">
        <th mat-header-cell *matHeaderCellDef>Codigo</th>
        <td mat-cell *matCellDef="let r">{{ r.codigo }}</td>
      </ng-container>

      <!-- Descricao/Vantagem -->
      <ng-container matColumnDef="descricao">
        <th mat-header-cell *matHeaderCellDef>Vantagem</th>
        <td mat-cell *matCellDef="let r" class="descricao-cell">
          {{ r.descricao }}
        </td>
      </ng-container>

      <!-- Valor Original -->
      <ng-container matColumnDef="valor">
        <th mat-header-cell *matHeaderCellDef>Valor</th>
        <td mat-cell *matCellDef="let r">{{ formatarValor(r.valor) }}</td>
      </ng-container>

      <!-- Valor Considerado -->
      <ng-container matColumnDef="valorConsiderado">
        <th mat-header-cell *matHeaderCellDef>Valor Considerado</th>
        <td mat-cell *matCellDef="let r">
          <span *ngIf="r.valorConsiderado !== null">
            {{ formatarValor(r.valorConsiderado) }}
          </span>
          <span *ngIf="r.valorConsiderado === null" class="valor-pendente">
            -
          </span>
        </td>
      </ng-container>

      <!-- Acoes -->
      <ng-container matColumnDef="acoes">
        <th mat-header-cell *matHeaderCellDef>Acoes</th>
        <td mat-cell *matCellDef="let r">
          <button
            mat-icon-button
            (click)="abrirModalEditar(r)"
            matTooltip="Editar rubrica"
          >
            <mat-icon color="primary">edit</mat-icon>
          </button>
          <button
            mat-icon-button
            color="warn"
            (click)="excluirRubrica(r)"
            matTooltip="Remover rubrica"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [class.row-selecionada]="row.selecionada"
      ></tr>
      <tr *matNoDataRow>
        <td class="sem-rubricas" [attr.colspan]="displayedColumns.length">
          Nenhuma rubrica cadastrada. A importação automática da folha ainda não está disponível: use 'Incluir Rubricas' para informar código, descrição e valor da folha, e preencha a fonte conferida.
        </td>
      </tr>
    </table>

    <!-- Resumo -->
    <div class="resumo-container" *ngIf="!loading">
      <div class="resumo-total">
        <strong>Total Selecionado:</strong>
        <span class="valor-total">{{ formatarValor(calcularTotal()) }}</span>
      </div>
    </div>

    <!-- Incluir Rubricas -->
    <div class="incluir-container">
      <button mat-stroked-button color="primary" (click)="abrirModalIncluir()">
        <mat-icon>add_circle</mat-icon> Incluir Rubricas
      </button>
    </div>
  </mat-card>

  <!-- Paragrafo do Ato -->
  <mat-card class="paragrafo-card">
    <h3 class="section-title">Paragrafo do Ato</h3>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Texto do paragrafo</mat-label>
      <textarea
        matInput
        rows="6"
        [(ngModel)]="paragrafoAto"
        (ngModelChange)="marcarAlteracao()"
        placeholder="Digite o paragrafo do ato..."
      ></textarea>
    </mat-form-field>
  </mat-card>

  <!-- Botoes de Acao -->
  <div class="acoes-container">
    <span class="aviso-nao-salvo" role="status">
      <ng-container *ngIf="alteracoesNaoSalvas">
        <mat-icon>warning</mat-icon> Alterações não salvas
      </ng-container>
    </span>
    <button mat-stroked-button color="warn" (click)="limparSelecao()">
      <mat-icon>clear</mat-icon> Limpar Selecao
    </button>
    <button mat-flat-button color="primary" (click)="salvar()" [disabled]="salvando">
      <mat-spinner *ngIf="salvando" diameter="20"></mat-spinner>
      <mat-icon *ngIf="!salvando">save</mat-icon>
      {{ salvando ? 'Salvando...' : 'Salvar' }}
    </button>
    <button mat-stroked-button color="primary" (click)="gerarDocumento()" [disabled]="gerandoDocumento">
      <mat-spinner *ngIf="gerandoDocumento" diameter="20"></mat-spinner>
      <mat-icon *ngIf="!gerandoDocumento">description</mat-icon>
      {{ gerandoDocumento ? 'Gerando...' : 'Gerar Documento' }}
    </button>
  </div>

  <!-- Modal Editar Rubrica -->
  <ng-template #modalEditarRubrica>
    <h2 mat-dialog-title>Cadastrar Justificativa Rubrica</h2>

    <mat-dialog-content class="modal-content">
      <p class="rubrica-nome">
        <strong>{{ rubricaSelecionada?.descricao }}</strong>
      </p>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Data Inicio Recebimento</mat-label>
        <input matInput type="date" [(ngModel)]="editDataInicioRecebimento" />
      </mat-form-field>

      <div class="form-row">
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Data DOE</mat-label>
          <input matInput type="date" [(ngModel)]="editDataDOE" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Pagina</mat-label>
          <input matInput [(ngModel)]="editPagina" placeholder="Ex: 216" />
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Rubrica e Fundamentacao Legal</mat-label>
        <textarea
          matInput
          rows="3"
          [(ngModel)]="editFundamentacao"
          placeholder="Ex: Lei n 18.356, de 10/05/2023"
        ></textarea>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Valor da Rubrica para o Ato (R$)</mat-label>
        <input matInput type="number" step="0.01" [(ngModel)]="editValor" />
      </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-stroked-button mat-dialog-close>
        <mat-icon>close</mat-icon> Cancelar
      </button>
      <button mat-flat-button color="primary" (click)="salvarEdicaoRubrica()">
        <mat-icon>save</mat-icon> Salvar
      </button>
    </mat-dialog-actions>
  </ng-template>

  <!-- Modal Incluir Rubricas -->
  <ng-template #modalIncluirRubricas>
    <h2 mat-dialog-title>Incluir novas Rubricas</h2>

    <mat-dialog-content class="modal-content">
      <mat-form-field><mat-label>Código</mat-label><input matInput [(ngModel)]="novaCodigo" /></mat-form-field>
      <mat-form-field><mat-label>Descrição</mat-label><input matInput [(ngModel)]="novaDescricao" /></mat-form-field>
      <mat-form-field><mat-label>Valor da folha</mat-label><input matInput type="number" min="0" step="0.01" [(ngModel)]="novaValor" /></mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-stroked-button mat-dialog-close>
        <mat-icon>close</mat-icon> Cancelar
      </button>
      <button mat-flat-button color="primary" (click)="incluirRubricas()">
        <mat-icon>add</mat-icon> Incluir
      </button>
    </mat-dialog-actions>
  </ng-template>
</div>
